import { makeRequest } from "./api";

export const FetchSms = async (type, page, limit, keyword) => {
  return makeRequest(
    `/api/admin/manage/sms/fetch?type=${type}&page=${page}&limit=${limit}&keyword=${keyword}`,
  );
};
